import Vue from 'vue'
import Vuex from 'vuex'
import error from './error.module'
import sidepanel from './sidepanel.module'
import auth from './auth.module'
import importing from './importing.module'
import company from './company.module'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedVacationsCount: 0,
    selectedVacationsHourlyCount: 0,
  },
  mutations: {
    SET_SELECTED_VACATIONS_COUNT(state, count) {
      state.selectedVacationsCount = count;
    },
    SET_SELECTED_VACATIONS_HOURLY_COUNT(state, count) {
      state.selectedVacationsHourlyCount = count;
    },
  },
  modules: {
    error,
    sidepanel,
    auth,
    importing,
    company
  }
})